class ValidateUsername extends ValidatePage {
    constructor(_parent) {
        // this.debug = true; // uncomment for debug obj
        super();
        this.parent = _parent;
        this.regex = /(?!.*[\.\-\_]{2,})^[a-zA-Z0-9\.\-\_]{3,24}$/gm;
        this.spaces = { regex: /\s/ }
        this.requirementsList = [];
        this.username = { elm: '', id: '', classlist: '',  value: '' };
        this.is_valid = false;

        this.debug = this.parent.debug.extends.ValidateUsername; // Turn on debugger in ValidatePage
    }  

    async _validate($this){
        this.username = this.parent.define_elem($this);
        var basic_validation = this.process_validations();

        if(basic_validation)
            this.is_valid = await this.validateEntry_username();
        else
            this.is_valid = basic_validation;

        if(this.debug)
            console.log(this, "ValidateUsername - debug");

        return this.is_valid;
    }

    async validateEntry_username(){
        try{
			var key = this.username.elm.attr('name');
			var s_perm = this.username.value;

            const response = await am.$.ajax({
                url: `/ajax/validate_username/all/?${key}=${encodeURIComponent(s_perm)}`, // Replace with your server-side endpoint URL
                method: 'GET',
                data: { username: this.username.value }
            });

            this.response = response;
            
            if(response.valid)
                return true
            else
                this.parent.failed_obj_push( { target: this.username.id, msg: get_language_translation('USERNAME_ALREADY_TAKEN') } );
                return false;
        }
        catch(e){
            console.log(e);
        }
    }

    process_validations(){
        if(!this.regex.test(this.username.value)){
            if(this.spaces.regex.test(this.username.value))
                this.parent.failed_obj_push( { target: this.username.id, msg: get_language_translation('LANG_LABEL_NO_SPACES') } );
            else
                this.parent.failed_obj_push( { target: this.username.id, msg: get_language_translation('LANG_PLEASE_USE_LETTERS_ONLY_A_Z_OR_NUMBERS_0_9_ONLY_IN_THIS_FIELD_NO_SPACES_OR_CHARS_ARE_ALLOWED') } );
            
            return false;
        }else{
            return true;
        }
    }
} 